import getUpcomingDestinations from "./getUpcomingDestinations";

export default (destinations=[])=>{
    const upcoming = getUpcomingDestinations(destinations);
    return (upcoming.length) ? upcoming[0] : null
}
